import cinemaController_initializeCinema from './cinema/cinemaController';
import loadSponsoredArticlesForDetailView from './loader/detailViewCinemaLoader';

window.o_auction_presentation = window.o_auction_presentation || {};
window.o_auction_presentation.private = window.o_auction_presentation.private || {};
window.o_auction_presentation.private.jlineup = window.o_auction_presentation.private.jlineup || {};


/*            */
window.o_auction_presentation.private.initializeCinema = cinemaController_initializeCinema

/*            */
window.o_auction_presentation.private.loadSponsoredArticlesForDetailView = loadSponsoredArticlesForDetailView;
